import React from 'react';
import DataSource from './src/datasource';

export { DoubleListBoxView, DoubleListBoxViewThemed } from './src/double-list-box-view';

export const DoubleListBox = data => (
  <DataSource data={data.data} i18n={data.i18n} />
);

export { doubleListBoxStyles } from './src/get-styles';

